export const SIDEBAR_COLORS = {
  textPrimary: 'var(--palette-semantic-text-primary)',
  textSecondary: 'var(--palette-semantic-text-caption)'
} as const;

export const thinScrollbarSx = {
  '&::-webkit-scrollbar': {
    width: '6px'
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent'
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: '#C2D0DA',
    borderRadius: '100px'
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: '#A6B8C4'
  }
} as const;
